<template>
  <Head :title="gym.title" />

  <BreezeAuthenticatedLayout>
    <main class="container">
      <div class="main pickupG">

        <div class="c-header">
          <Link href="#" onclick="window.history.back(); return false;" class="c-header__back">
            <img src="/images/icons/icon-chevron-left.svg" alt="back">
          </Link>
          <h2 class="c-header--h2">{{ gym.title }}</h2>
        </div>

        <div v-if="$page.props.flash.message" class="message">
          {{ $page.props.flash.message }}
        </div>

        <div class="mt-24">
          <img :src="gym.image">
        </div>

        <div class="ticker-wrap">
          <div class="ticker-head">INFO</div>
          <div class="ticker" ref="ticker" :style="{ display: isVisible ? 'block' : 'none' }">
            <ul>
              <li v-for="(item, index) in items" :key="index" class="ticker-item" :class="{ run: runningIndex === index }">
                <a @click="onItemClick(index)" :href="item.url" class="ticker_link" target="_blank" rel="noopener, noreferrer">
                  <span class="ticker-date">{{ item.date }}</span>
                  <span class="ticker-title">{{ item.title }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="pickupG_something mt-24">
          
          <div class="c-tab">
            <ul class="c-tab_wrap">
              <li class="c-tab_wrap_list">
                <Link :href="`/gyms/${gym.slug}`" class="c-tab_wrap_list_item" :class="{ active: !category_id }">すべて</Link>
              </li>
              <li v-for="category in categories" :key="category.id" class="c-tab_wrap_list">
                <Link :href="`/gyms/${gym.slug}?category_id=${category.id}`" class="c-tab_wrap_list_item" :class="{ active: category.id == category_id }">{{ category.name }}</Link>
              </li>
            </ul>
          </div>

          <div class="pickupG_wrap">
            <!-- start v-for -->
            <div v-for="grade in grades" :key="grade.id" class="pickupG_wrap_row">
              <Link :href="gradeUrl(gym.slug, grade.id)" class="pickupG_wrap_row_link nowrap">

                <div class="pickupG_wrap_row_link_grade">
                  <div class="pickupG_wrap_row_link_grade_title">
                    <span class="pickupG_wrap_row_link_grade_title_color" :style="{ backgroundColor: grade.color }"></span>
                    <span class="pickupG_wrap_row_link_grade_title_text">
                      {{ grade.title }}
                    </span>
                  </div>
                </div>

                <div class="pickupG_wrap_row_link_complete">
                  <span v-if="projectCompleteRate[grade.id]===1" class="pickupG_wrap_row_complete_message">
                    <img src="/images/icons/icon-comp.svg">
                  </span>
                  <span :class="{ 'red': projectCompleteRate[grade.grade]===1 }">
                    <span v-if="$page.props.auth.user">{{projectCompleteCount[grade.id]}}/</span>{{projectTotalCount[grade.id]}}
                  </span>
                </div>

              </Link>
            </div>
            <!-- end v-for -->
          </div>

          <!-- admin or 特定gym owner only -->
          <div class="admin-area" v-if="(auth.user && user.can.isAdmin) || (auth.user && user.can.isOwnerHigher && gym.users && gym.users.length > 0 && auth.user.id == gym.users[0].pivot.user_id)">
            <h3 class="admin-area_heading c-heading-h4">管理者エリア</h3>
            <div class="c-button-wrap">
              <Link :href="`/gyms/${gym.id}/edit`" class="c-button half">ジムを編集</Link>
              <Link :href="`/projects/create/${gym.id}`" class="c-button half">課題を追加</Link>
              <Link :href="`/categories/${gym.id}`" class="c-button half">課題カテゴリ一覧</Link>
              <Link :href="`/walls/${gym.id}`" class="c-button half">ウォール一覧</Link>
              <Link :href="`/grades/${gym.id}`" class="c-button half">グレード一覧</Link>
              <Link @click="destroy(gym.id)" class="c-button red half" v-if="auth.user && user.can.isAdmin">このジムを削除</Link >
            </div>
          </div>

        </div>
      </div>

      <Side />
    </main>
  </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  import Side from '@/Shared/Side'

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      Inertia,
      Side,
    },
    props: {
      gym: Object,
      auth: Object,
      grades: Object,
      categories: Object,
      category_id: String,
      user: Object,
      projectTotalCount: Object,
      projectCompleteCount: Object,
      projectCompleteRate: Object,
    },
    data() {
      return {
        animTime: 5000,
        speed: 30,
        limit: 0,
        items: [
          { date: '2023/05/26', title: '町田コンペ【ROCK ON】が帰ってきた!!!', url: 'https://noborock-climbing.com/news/%e7%94%ba%e7%94%b0%e3%82%b3%e3%83%b3%e3%83%9a%e3%80%90rock-on%e3%80%91%e3%81%8c%e5%b8%b0%e3%81%a3%e3%81%a6%e3%81%8d%e3%81%9f/' },
          { date: '2023/04/10', title: 'NOBO FLASH シューズ抽選結果発表！', url: 'https://noborock-climbing.com/news/nobo-flash-%e3%82%b7%e3%83%a5%e3%83%bc%e3%82%ba%e6%8a%bd%e9%81%b8%e7%b5%90%e6%9e%9c%e7%99%ba%e8%a1%a8%ef%bc%81/' },
          { date: '2023/04/03', title: 'NOBO FLASH ランキング！', url: 'https://noborock-climbing.com/news/nobo-flash-%e3%83%a9%e3%83%b3%e3%82%ad%e3%83%b3%e3%82%b0/' },
          { date: '2023/04/02', title: '渋谷店スタッフ募集中！', url: 'https://noborock-climbing.com/news/%e6%b8%8b%e8%b0%b7%e5%ba%97%e3%82%b9%e3%82%bf%e3%83%83%e3%83%95%e5%8b%9f%e9%9b%86%e4%b8%ad%ef%bc%81/' },
        ],
        ticker: null,
        runningIndex: -1,
        previousIndex: -1,
        animId: null,
        isRunning: false,
        isVisible: true,
      };
    },
    mounted() {
      this.ticker = this.$refs.ticker;
      window.addEventListener('resize', this.onResize);
      this.onResize();
    },
    beforeUnmount() {
      clearInterval(this.animId);
      window.removeEventListener('resize', this.onResize);
    },
    methods: {
      back() {
        window.history.back();
      },
      gradeUrl(slug, grade) {
        let tmpUrl = slug + '/' + grade;
        if(this.category_id) {
          tmpUrl += '?category_id=' + this.category_id
        }
        return tmpUrl;
      },
      destroy(id) {
        if (confirm('本当に削除しますか？')) {
          this.$inertia.delete(route("gyms.destroy", id));
        }
      },
      loadTicker() {
        this.tickerAnim();
        this.animId = setInterval(this.tickerAnim, this.animTime);
        this.isRunning = true;
      },
      tickerAnim() {
        const items = this.ticker.querySelectorAll('.ticker-item');
        const running = this.ticker.querySelector('.run');
        let idx, link, first, next;
        if (!running) {
          first = items[0];
          link = first.querySelector('a');
          first.classList.add('fadeInDown', 'run');
          first.style.zIndex = 1;
          setTimeout(() => this.textMove(link), 1000);
        } else {
          for (let i = 0; i < items.length; i++) {
            if (items[i] == running) {
              idx = i;
              break;
            }
          }
          next = items[(idx + 1) % items.length];
          running.classList.replace('fadeInDown', 'fadeOutDown');
          setTimeout(() => {
            running.classList.remove('fadeOutDown', 'run');
            running.style.zIndex = -1;
            link = running.querySelector('a');
            link.style.transform = 'none';
            next.classList.add('fadeInDown', 'run');
            next.style.zIndex = 1;
            link = next.querySelector('a');
            setTimeout(() => this.textMove(link), 1000);
          }, 300);
        }
      },
      textMove(elm) {
        const move = elm.parentNode.clientWidth - elm.clientWidth;
        if (move < 0) {
          elm.style.transform = `translateX(${move}px)`;
          elm.style.transitionDuration = `${Math.abs(move) / this.speed}s`;
        }
      },
      onItemClick(index) {
        if (this.runningIndex !== index) {
          this.previousIndex = this.runningIndex;
          this.runningIndex = index;
          const previousItem = this.$refs.ticker.querySelectorAll('.ticker-item')[this.previousIndex];
          if (previousItem) {
            previousItem.classList.remove('run');
          }
          const currentItem = this.$refs.ticker.querySelectorAll('.ticker-item')[this.runningIndex];
          currentItem.classList.add('run');
          const link = currentItem.querySelector('a');
          link.style.transform = 'none';
          setTimeout(() => this.textMove(link), 1000);
        }
      },
      onResize() {
        const windowWidth = window.innerWidth;
        if (windowWidth <= this.limit) {
          this.ticker.style.display = 'none';
          clearInterval(this.animId);
          this.isRunning = false;
          this.isVisible = false;
        } else {
          if (!this.isRunning) {
            this.ticker.style.display = 'block';
            this.loadTicker();
            this.isVisible = true;
          }
        }
      },
    }
  }
</script>
